'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { MyAsideNavigationLayout } from '../_components/MyAsideNavigationLayout';
const Layout = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  const pathname = usePathname();
  if (pathname?.startsWith("/donation/my/etc/event/")) {
    return children;
  }
  let t1;
  if ($[0] !== children) {
    t1 = <MyAsideNavigationLayout>{children}</MyAsideNavigationLayout>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Layout;